module.exports = __webpack_public_path__ + "img/id_card.b73e756f.svg";